const locationsStatus = {
    active: 'ACTIVE',
    inactive: 'INACTIVE',
    closed: 'CLOSED',
}

export default locationsStatus